export const GQL_LIMIT = 2e9;
export const NEW_DAYS = 14;
export const FAVOURITES_PLAYLIST_TITLE = "Favourites";
export const FAVOURITES_PLAYLIST_DEFAULT_DESC = "Playlist containing user favourites";
